import { SVGProps } from "react";

export default function TrashBinIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#DF1C41", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17.5 4.98698C14.725 4.71198 11.9333 4.57031 9.15 4.57031C7.5 4.57031 5.85 4.65365 4.2 4.82031L2.5 4.98698"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08594 4.13906L7.26927 3.0474C7.4026 2.25573 7.5026 1.66406 8.91094 1.66406H11.0943C12.5026 1.66406 12.6109 2.28906 12.7359 3.05573L12.9193 4.13906"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7057 7.61719L15.1641 16.0089C15.0724 17.3172 14.9974 18.3339 12.6724 18.3339H7.3224C4.9974 18.3339 4.9224 17.3172 4.83073 16.0089L4.28906 7.61719"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.60938 13.75H11.3844"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91406 10.4141H12.0807"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
